import React from 'react'

const EstateProximity = ({proximityInSeconds}) => {
  if(proximityInSeconds ==  null || proximityInSeconds == 0) { return null }
  
  const valueToDisplay = Math.round(proximityInSeconds / 60, 0);
  
  return <div>
             {valueToDisplay} <small><small>minutes</small></small>
         </div>
}
export default EstateProximity 



/** WEBPACK FOOTER **
 ** ./app/components/EstateProximity.jsx
 **/